var map = {
  "./cs.messages.tsx": [
    "49908",
    [
      45545
    ]
  ],
  "./en.messages.tsx": [
    "38217",
    [
      45906
    ]
  ],
  "./sl.messages.tsx": [
    "73961",
    [
      64810
    ]
  ],
  "./hu.messages.tsx": [
    "11617",
    [
      56310
    ]
  ],
  "./de.messages.tsx": [
    "4125",
    [
      9002
    ]
  ],
  "./it.messages.tsx": [
    "87303",
    [
      93800
    ]
  ],
  "./pl.messages.tsx": [
    "62774",
    [
      60935
    ]
  ],
  "./fr.messages.tsx": [
    "15102",
    [
      95279
    ]
  ],
  "./sk.messages.tsx": [
    "48636",
    [
      96561
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 32649;
module.exports = __rspack_async_context;
